import { render } from "./footer-bar.vue?vue&type=template&id=2b151172"
import script from "./footer-bar.vue?vue&type=script&lang=js"
export * from "./footer-bar.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/MBx/MBx/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__